module.exports = __webpack_public_path__ + "static/img/1.5284954.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/zh/1.png
// module id = 46RU
// module chunks = 0